export default "__VITE_ASSET__8qe6BHMM__"